import fetchWindowObject from "@/lib/fetchWindowObject"
import Http from "@/lib/Http"
import StripeKey from "@/lib/StripeKey"
import { i18n } from "@/lib/vue/plugins/i18n"

class StripeMounter {
  cartId = null
  listing = null
  cart = null
  buttonStyle = null
  totalCents = null
  addonOption = null
  stripeConfig = {
    requestPayerName: true,
    requestPayerEmail: true,
    requestShipping: true,
    requestPayerPhone: true,
    shippingOptions: [
      {
        id: "free-shipping",
        label: "Free Shipping",
        detail: "Free returns in 7 days",
        amount: 0,
      },
    ],
  }
  defaultButtonStyle = {
    paymentRequestButton: {
      type: "default",
      height: "50px",
    },
  }

  constructor(cartId, listing = null, options = null) {
    this.cartId = cartId
    this.listing = listing
    this.buttonStyle = options?.buttonStyle
    this.totalCents = options?.totalCents
    this.addonOption = options?.addonOption
  }

  setAddOn(option) {
    this.addonOption = option
  }

  setTotalCents(totalCents) {
    this.totalCents = totalCents
    this.paymentRequest.update({
      total: this.totalUpdate(totalCents),
    })
  }

  async initializePaymentRequest() {
    const StripeLib = await fetchWindowObject("Stripe")
    const stripe = StripeLib(StripeKey)
    const self = this
    let paymentData = null
    if (this.listing) {
      paymentData = this.paymentDataFromListing()
    } else if (this.cartId) {
      const response = await this.cartRequest()
      paymentData = response.data
    }
    this.paymentRequest = stripe.paymentRequest({
      ...paymentData,
      ...this.stripeConfig,
    })

    this.paymentRequest.on("shippingaddresschange", async (ev) => {
      if (!self.cartId) {
        await self.createCartRequestWithListing()
      }
      const response = await Http.patch("/cart/stripe/shipping", {
        cartID: self.cartId,
        shippingAddress: ev.shippingAddress,
      })
      const result = response.data
      let updates = {
        status: "success",
        shippingOptions: result.supportedShippingOptions,
      }
      if (self.listing) {
        updates.total = this.totalUpdate(self.totalCents + result.supportedShippingOptions[0].amount)
      }
      ev.updateWith(updates)
    })

    this.paymentRequest.on("shippingoptionchange", (ev) => {
      let updates = {
        status: "success",
      }
      if (self.listing) {
        updates.total = this.totalUpdate(self.totalCents + ev.shippingOption.amount)
      }
      ev.updateWith(updates)
    })

    this.paymentRequest.on("paymentmethod", async (ev) => {
      if (!self.cartId) {
        await self.createCartRequestWithListing()
      }
      try {
        const response = await Http.post("/cart/stripe", {
          cartID: self.cartId,
          shippingAddress: ev.shippingAddress,
          payer: {
            email: ev.payerEmail,
            name: ev.payerName,
          },
        })
        const result = response.data
        const { clientSecret, successPath } = result
        const { error: confirmError } = await stripe.confirmCardPayment(
          clientSecret,
          { payment_method: ev.paymentMethod.id },
          { handleActions: false },
        )
        if (confirmError) {
          ev.complete("fail")
        } else {
          Turbo.visit(successPath, { action: "replace" })
          ev.complete("success")
        }
      } catch (error) {
        if (error.response) {
          const { errors } = error.response.data
          alert(errors.join(", "))
          ev.complete("fail")
        }
      }
    })
    const elements = stripe.elements()
    const prButton = elements.create("paymentRequestButton", {
      paymentRequest: this.paymentRequest,
      style: this.buttonStyle || this.defaultButtonStyle,
    })

    return { button: prButton, payment_request: this.paymentRequest }
  }

  async cartRequest() {
    const response = await Http.get("/cart/stripe", {
      params: {
        cartID: this.cartId,
      },
    })
    return response
  }

  async createCartRequestWithListing() {
    const response = await Http.post("/api/social_pay/carts", {
      listing_id: this.listing.id,
      framing: this.addonOption,
    })
    this.cartId = response.data.id
  }

  paymentDataFromListing() {
    return {
      country: config.marketHandle.toUpperCase(),
      currency: i18n.tc("market.currency.code").toLowerCase(),
      total: {
        label: `Total (${i18n.tc("market.currency.sign")})`,
        amount: this.totalCents,
      },
    }
  }

  totalUpdate(amount) {
    return {
      label: `Total (${i18n.tc("market.currency.sign")})`,
      amount: amount,
    }
  }
}

export default StripeMounter
